module.exports = __webpack_public_path__ + "static/multi-60b6a8989dcbf10867414339fa869a24.jpg";